module.exports = __webpack_public_path__ + "img/autotxt.f997f8af.webp";